import { INextPageProps } from "../../../../app";
import { NextPage } from "next";
import { languageConfig } from "../../../../i18n/language-config";
import { PageModular } from "../../../../contentful/PageModularModule";
import { ModularPage } from "domain/CommonModules/ModularPage";
import { StatusCodes } from "http-status-codes";
import dynamic from "next/dynamic";
import { useEffect, useMemo } from "react";
import { useLocale, useMessages } from "next-intl";
import {
  buildTextLinkParams,
  buildTextLinkPageProps,
  TextLinkResponse,
} from "../../../../utils/text-link/text-link-api";
import { isValidTextLinkId } from "../../../../utils/text-link/text-link-id";
import {
  TextLinkParamsContext,
  syncTextLinkParams,
  setStoredKlinkId,
} from "../../../../utils/text-link/TextLinkParamsContext";

interface Props extends INextPageProps {
  page: PageModular;
  pageExists: boolean;
  partnerName: string;
  textLinkData: TextLinkResponse | null;
  textLinkId: string;
}

const Error = dynamic(() => import("../../../_error"));

const PartnerTextLinkPage: NextPage<Props> = (props) => {
  const { page, pageExists, partnerName, textLinkData, textLinkId } = props;
  const locale = useLocale();
  const messages = useMessages();

  const textLinkParams = useMemo(() => {
    const params = buildTextLinkParams(textLinkData);
    syncTextLinkParams(params);
    if (isValidTextLinkId(textLinkId)) {
      setStoredKlinkId(textLinkId);
    }
    return params;
  }, [textLinkData, textLinkId]);

  useEffect(() => {
    globalThis.landingPage = partnerName;
  }, []);

  if (!pageExists) {
    return <Error statusCode={StatusCodes.NOT_FOUND} locale={locale} messages={messages} />;
  }

  return (
    <TextLinkParamsContext.Provider value={textLinkParams}>
      <ModularPage
        modularPage={page}
        pageTypeDataLayer="Partner Landing Page"
        keyString="partner-landing-page-module-wrapper"
      />
    </TextLinkParamsContext.Provider>
  );
};

export const getServerSideProps = async (context) => {
  const { lang, partnerLandingPageName: partnerName, textLinkId } = context.params;

  if (!languageConfig.isLanguageAllowedInPath(lang)) {
    return { notFound: true };
  }

  const locale = languageConfig.mapLanguageToLocale(lang);
  const slug = `${lang}/partner/${partnerName}`;
  return buildTextLinkPageProps(locale, slug, partnerName, textLinkId);
};

export { PartnerTextLinkPage };
export default PartnerTextLinkPage;
